export default "__VITE_ASSET__b$zJFQBw26_tBLE5EuBOig__"